import { useSelector } from 'react-redux';

export function useSidePanel() {
    return useSelector((state) => state.ui.sidePanel);
}
